import React from "react";
import ActionReportBadge from "./ActionReportBadge";
import { ATTENDANCE_ATTENDED } from "../../utils/attendance";

interface AppointmentBadgesProps {
  attendanceStatusId?: number | null;
  hasActionReport?: boolean;
  hasTherapistAnswered?: boolean;
  size?: number;
  /**
   * How the group sits in its tile. Supplied by the caller and not guessed here: the corner offset
   * a month cell wants is not the one a card wants, and the day-list row does not position the
   * group at all — it pushes it to the end of a flex row. Flattening those into one rule moved the
   * icons and changed the size of the tiles they sit in.
   */
  style?: React.CSSProperties;
  as?: "div" | "span";
}

const BASE_STYLE: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 2,
};

/**
 * The badges that sit on an appointment, in one place.
 *
 * Every calendar view had its own copy of the same three conditions, which is why adding a third
 * badge would have meant editing a dozen of them.
 */
const AppointmentBadges: React.FC<AppointmentBadgesProps> = ({
  attendanceStatusId,
  hasActionReport,
  hasTherapistAnswered,
  size = 12,
  style,
  as = "div",
}) => {
  const attended = attendanceStatusId === ATTENDANCE_ATTENDED;

  if (!attended && !hasActionReport && !hasTherapistAnswered) return null;

  const Wrapper = as;

  return (
    <Wrapper style={{ ...BASE_STYLE, ...style }}>
      {attended && <ActionReportBadge variant="attended" size={size} />}
      {hasActionReport && <ActionReportBadge variant="saved" size={size} />}
      {hasTherapistAnswered && <ActionReportBadge variant="report" size={size} />}
    </Wrapper>
  );
};

export default AppointmentBadges;
